import { FC } from 'react';
import classNames from 'classnames';

import CommonMetaTags from '../MetaTags/CommonMetaTags';
import getClassNames from '../../utils/getClassNames';
import styles from './Layout.module.scss';
import FeatureFlagModal from '../FeatureFlagModal';

export type LayoutProps = {
  /**
   * Reserve space for fixed header on desktop.
   * On by default. If off, it will override withFixedHeaderMobile.
   */
  withFixedHeader?: boolean;
  /**
   * Reserve space for fixed header on mobile.
   * On by default.
   */
  withFixedHeaderMobile?: boolean;
  includeCommonMetaTags?: boolean;
  overscrollColor?: 'ivory' | 'midnight';
  noindex?: boolean;
  children: React.ReactNode;
};

const Layout: FC<LayoutProps> = ({
  children,
  withFixedHeader = true,
  withFixedHeaderMobile = true,
  includeCommonMetaTags = true,
  noindex = false,
  overscrollColor,
}) => (
  <>
    {includeCommonMetaTags && (
      <CommonMetaTags noindex={noindex} />
    )}
    <div
      className={getClassNames(styles, 'root', classNames({
        withFixedHeader,
        withFixedHeaderMobile: withFixedHeader ? withFixedHeaderMobile : false,
        [`overscroll-${overscrollColor}`]: overscrollColor,
      }))}
    >
      {children}
      <FeatureFlagModal />
    </div>
  </>
);

export default Layout;
